import { ensureConfig } from "./configuration-service";
import { TSmokeballTier } from "./smokeball-authenticator";

export const getMatterLink = (matterId: string, tier: TSmokeballTier) => {
  const regionConfig = ensureConfig();

  const appUrl = regionConfig.WebappUrl;

  // If the firm is prosper+ then we need to open the matter from the Smokeball destop app.
  if (tier === "SMK003") {
    return `smokeball://MatterManagement.MatterUriProvider?matterId=${matterId}`;
  }

  return `${appUrl}#/billing/view-matter/${matterId}/dashboard`;
};
